import {
  formatError,
  // login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp
} from '../../services/AuthService';
import { login } from '../../services/Login/LoginService';

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const NAVTOGGLE = 'NAVTOGGLE';

export function signupAction(email, password, navigate) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, response.data.expiresIn * 1000);
        dispatch(confirmedSignupAction(response.data));
        navigate('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  localStorage.removeItem('userDetails');
  navigate('/login');

  return {
    type: LOGOUT_ACTION
  };
}

export function loginAction(userName, password, navigate) {
  return (dispatch) => {
    const loginPayload = {
      userName: userName,
      password: password
    };
    login(loginPayload)
      .then((response) => {
        let lUserDetails = {};
        if (response?.success) {
          const userDetails = response?.returnResult || {};
          lUserDetails.userName = userDetails?.userName;
          lUserDetails.role = userDetails?.roleGUID;
          lUserDetails.expiresIn = 20000;
          lUserDetails.userGUID = userDetails?.userGUID;
          saveTokenInLocalStorage(lUserDetails);
          runLogoutTimer(dispatch, lUserDetails.expiresIn * 1000, navigate);
          dispatch(loginConfirmedAction(lUserDetails));
          navigate('/dashboard');
        } else {
          const errorMessage = response?.message || 'Failed to Login';
          if (window.showSnackbar) {
            window.showSnackbar({
              message: errorMessage,
              variant: 'error'
            });
          }

          dispatch(loginFailedAction(errorMessage));
        }
      })
      .catch((error) => {
        let errorMessage = 'Failed to Login';
        if (typeof error === 'string') {
          errorMessage = error;
        } else if (error?.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error?.message) {
          errorMessage = error.message;
        }

        if (window.showSnackbar) {
          window.showSnackbar({
            message: errorMessage,
            variant: 'error'
          });
        }

        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status
  };
}

export const navtoggle = () => {
  return {
    type: 'NAVTOGGLE'
  };
};
